import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdPriorityHigh } from 'react-icons/md';

export default function ErrorPage() {
    const { t } = useTranslation();
    return (
        <div className={'margin flex h-screen flex-col items-center justify-center'}>
            <MdPriorityHigh className={'text-6xl text-SM-yellow sm:text-8xl'} />
            <h1 className={'text-center'}>{t('translation:ERROR_PAGE.ERROR_OCCURRED')}</h1>
            <h4 className={'text-center'}>{t('translation:ERROR_PAGE.DONT_WORRY')}</h4>
            <a href={'/'} className={'mt-2'}>
                <button className={'btn-filled bg-SM-yellow text-white ring-SM-yellow/50'}>
                    {t('translation:ERROR_PAGE.GO_BACK_HOME')}
                </button>
            </a>
        </div>
    );
}
